import Vue from 'vue'
import Router from 'vue-router'

import LoginPage from './components/page/LoginPage.vue'
import UserLayout from './components/page/UserLayout.vue'
import Board from "./components/board/Board.vue";
import GradeRecord from "./components/page/GradeRecord.vue";
import ApplyRecord from "./components/page/ApplyRecord.vue";
import ResetPassword from "./components/page/ResetPassword.vue";
import BonusApply from "./components/page/BounsApply.vue";
import BonusRecords from './components/page/BonusRecords.vue'
import ScoreRecord from './components/page/ScoreRecord.vue'
import WeeklyReport from './components/page/WeeklyReport.vue'
import MonthlyReport from './components/page/MonthlyReport.vue'
import MonthlyReportView from './components/page/MonthlyReportView.vue'
import DataQuery from './components/page/DataQuery.vue'
Vue.use(Router)

export default new Router({
    mode: 'history',
    base: '/student/',
    routes: [
        {
            path: '/',
            name: 'index',
            redirect: '/login',
            component: UserLayout,
            children: [
                {
                    path: '/board',
                    name: 'board',
                    component: Board,
                },
                {
                    path: '/grade_record',
                    name: 'grade_record',
                    component: GradeRecord,
                },
                {
                    path: '/score_record',
                    name: 'score_record',
                    component: ScoreRecord,
                },
                {
                    path: '/apply_record',
                    name: 'apply_record',
                    component: ApplyRecord,
                },
                {
                    path: '/bonus_apply',
                    name: 'bonus_apply',
                    component: BonusApply,
                },
                {
                    path: '/bonus_records',
                    name: 'bonus_records',
                    component: BonusRecords,
                },
                {
                    path: '/password_change',
                    name: 'password_change',
                    component: ResetPassword,
                },
                {
                    path: '/weekly_report',
                    name: 'weekly_report',
                    component: WeeklyReport,
                },
                {
                    path: '/monthly_report',
                    name: 'monthly_report',
                    component: MonthlyReport,
                },
                {
                    path: '/monthly_report_view',
                    name: 'monthly_report_view',
                    component: MonthlyReportView,
                },
                {
                    path: '/data_query',
                    name: 'data_query',
                    component: DataQuery,
                },
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: LoginPage
        }
    ]
})